import React from 'react'

import Button from '../components/Button'
import Layout from '../components/Layout'
import Paper from '../components/Paper'
import SEO from '../components/Seo'
import TextField from '../components/TextField';
import Typography from '../components/Typography'

import compStyles from '../pageComponents/contactUs/contactUs.module.scss'

const inputs = [
  'name',
  'email',
  'phone',
  'message'
]
class EnquiryPage extends React.Component {

  render () {
    return (
    <Layout>
      <SEO title='ವಿಚಾರಣೆ ಪತ್ರ' />
      <Paper>
        <section className={compStyles.section}>
          <Typography variant="h2" className={compStyles.heading}>ವಿಚಾರಣೆ ಪತ್ರ</Typography>
          <form action="send_mail.php" name="contactform" method="post" className={compStyles.enquiry__container} onSubmit={(results) => {
            const valueFields = results.target
            const values = inputs.map(field => {
              return {
                [field]: valueFields[field].value
              }
            })
            console.log(values)
          }}>
            <div className={compStyles.enquiry__inputField}>
              <Typography variant="body2" className={compStyles.heading}>ನಿಮ್ಮ ಪ್ರಶ್ನೆಗಳಿಗೆ ನಾವು ಉತ್ತರಿಸುತ್ತೇವೆ.</Typography>
            </div>
            <div className={compStyles.enquiry__inputField}>
              <TextField name={inputs[0]} label="ಹೆಸರು *" variant="outlined"></TextField>
            </div>
            <div className={compStyles.enquiry__inputField}>
              <TextField name={inputs[1]} label="ಇಮೇಲ್ ಐಡಿ *" variant="outlined"></TextField>
            </div>
            <div className={compStyles.enquiry__inputField}>
              <TextField name={inputs[2]} label="ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆ *" variant="outlined"></TextField>
            </div>
            <div className={compStyles.enquiry__inputField}>
              <TextField name={inputs[3]} label="ನಿಮ್ಮ ಸಂದೇಶ: *" variant="outlined" multiline={true} rows="5"></TextField>
            </div>

            <div className={compStyles.enquiry__inputField}>
              <Button className={compStyles.enquiry__button} type='submit' variant='contained' color='secondary'>ಸಲ್ಲಿಸು</Button>
            </div>
          </form>
        </section>
      </Paper>
    </Layout>
    )
  }
}

export default EnquiryPage
